<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            
        </section>
  
            <!-- Main content -->
            <section class="content">
                <div class="box">
                    
                    <div class="box-body" style="min-height:400px;">
                      <h3> <strong>Settings</strong></h3>
                    <hr>
    
<div > 
    <div class="row">
                        <div class="col-sm-9">
                                <a :href="'#/userProfile/' + this.userId  + '/update'"><h5 for="inputPassword" style="text-align: left;">Update Profile</h5></a> 
                                <p id="inputPassword" style="text-align: left; font-size: 9pt;">Update your user profile information.</p> </div>
                                                <!--div class="col-sm-3"><i style="width:30%" class="ti-user"/></div-->

</div>
</div>
                       <div > 
                        <hr>
                                <button style="background:none; border:none;"  v-on:click="deleteProfile"><h5 for="inputPassword" style="text-align: left; color: red;">Delete Profile</h5></button>
                                <p  style="text-align: left; font-size: 9pt;">Delete your user profile.</p> </div>
                                <hr>
                    </div>
                

                    <hr>
                                <div class="col-md-12 row-block"> <a  class="btn btn-primary btn-block"  href="#/">Go Back to Main Page</a> </div>

                    <hr>
                 <br>
                 <br>
                    </div>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
const cliStorage = require('../services/libraries/clientStoragelib')
const cliStorNames = cliStorage.clientStorageNames
const Auth = require('../services/Authentication/auth')
const to = require('await-to-js').default
const cliStoreOps = require('../common/clientStorageOperations')

  export default {
    name: 'Settings',
    props:['accident'],
    async beforeMount(){
        const userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
  let userErr, userRes
          [userErr, userRes] = await to(Auth.getUser({ UID: userToken }));
          if (userErr) {
            console.log("getting user userErr", userErr.response);
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')

          } 
    },
//need to clear fro local str maybe
    created(){
     
    this.userId = this.$cookie.get(cliStorNames.USER_ID.name)
    },
    beforeDestroy(){
      
},
data(){
    return{
        userId: ''
    }
},
methods:
{   
    deleteProfile: async function(){
        let userNo, userYes;
        [userNo, userYes] = await to(this.$confirm("Are you sure you want to delete your profile? \nOnce you do this, it cannot be undone. All of your data will be lost." ,  'WARNING', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'}))

        if (userNo){
            console.log("no")
        }
    //     if(userYes){
    //         let confirmNo, confirmYes;
    //         [confirmNo, confirmYes] = await to(this.$confirm("Are you absolutely sure you want to delete your profile?",  'WARNING', {
    //              auth: true,
    //     confirmButtonText: 'Yes',
    //     cancelButtonText: 'No'})
    // )

        if(userYes){
            const id = "dg-input-elem"
        var element = document.getElementById(id);
        console.log(element)
            console.log("confirmed Deletion", userYes)
            let dialogCancel, dialogConfirm;
            [dialogCancel, dialogConfirm] = await to(
            this.$dialog
  .prompt({
    body: "Verify your password to permanently delete your account.",
  }, {
    promptHelp: 'Please type in your password and press "[+:okText]"'
  }))

  if (dialogConfirm){
      console.log("DC", dialogConfirm)
      let delErr, delRes;
      [delErr, delRes] = await to(this.verifyUser(dialogConfirm.data))
      
  }
        //}
        }
        
    },

    verifyUser: async function(password){
        let userErr, userRes ;
        const Token = this.$cookie.get(cliStorNames.USER_TOKEN.name)
        console.log("TokenC", Token);

        [userErr, userRes] = await to(Auth.getUser({UID:Token}))
        if(userRes){

        }
        const email = userRes.data.users[0].email;
        let userCredentials = {
            email,
            password
        }
        let signInErr, signInRes;
        [signInErr, signInRes] = await to(Auth.SignInUser(userCredentials))
        if (signInErr){
            const errorMsg = signInErr.response.data.error.message 
           this.$confirm("Error:" + errorMsg,  'ERROR', {
        confirmButtonText: 'OK'
        }).then(res=> {
            throw signInErr
        })
        }

        const newToken =signInRes.data.idToken
        let delErr, delRes;
        [delErr, delRes] = await to(Auth.removeUser({UID:newToken}))
        if (delErr){
            this.$confirm("Unable to delete account. Please Try again later.",  'ERROR', {
        confirmButtonText: 'OK'
        }).then(res=>{
            throw delErr
        })

        }

        else if(delRes){
             this.$cookie.delete(cliStorNames.USER_TOKEN.name)
        this.$cookie.delete(cliStorNames.REFRESH_TOKEN.name)
        console.log(cliStorNames)
        for (const [key, value] of Object.entries(cliStorNames)){
            localStorage.removeItem(value.name)
        }
            this.$confirm("Account Deleted. We are sad to see you go.",  'INFO', {
        confirmButtonText: 'OK'
        })
        this.$router.push("/login")
        }
    },
    goHome: function(){
  

          this.$router.push('/')

    }
}
  }
</script>
<style scoped>
.dg-btn-loader .dg-circle {
  background-color: green;
}

.dg-btn--ok {
  border-color: green;
}




// WEBPACK FOOTER //
// Settings.vue?87eaad8a